/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as DeletionStatusRouteImport } from './routes/deletion-status'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SubprocessorsRouteImport } from './routes/subprocessors'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppAdAccountsRouteImport } from './routes/app.ad-accounts'
import { Route as AppAdminRouteImport } from './routes/app.admin'
import { Route as AppAudiencesRouteImport } from './routes/app.audiences'
import { Route as AppInsightsRouteImport } from './routes/app.insights'
import { Route as AppOnboardingRouteImport } from './routes/app.onboarding'
import { Route as AppOrganizationsRouteImport } from './routes/app.organizations'
import { Route as AppSettingsRouteImport } from './routes/app.settings'
import { Route as AuthErrorRouteImport } from './routes/auth.error'
import { Route as InvitationsIdRouteImport } from './routes/invitations.$id'
import { Route as AppAdminIndexRouteImport } from './routes/app.admin.index'
import { Route as AppAdminAiUsageRouteImport } from './routes/app.admin.ai-usage'
import { Route as AppAdminCostRouteImport } from './routes/app.admin.cost'
import { Route as AppAdminLaunchFailuresRouteImport } from './routes/app.admin.launch-failures'
import { Route as AppAdminLearningRouteImport } from './routes/app.admin.learning'
import { Route as AppAdminModelsRouteImport } from './routes/app.admin.models'
import { Route as AppAdminQueuesRouteImport } from './routes/app.admin.queues'
import { Route as AppAdminWatchdogRouteImport } from './routes/app.admin.watchdog'
import { Route as AppCampaignsIndexRouteImport } from './routes/app.campaigns.index'
import { Route as AppCampaignsCampaignIdRouteImport } from './routes/app.campaigns.$campaignId'
import { Route as AppCampaignsNewRouteImport } from './routes/app.campaigns.new'
import { Route as AppSettingsAutopilotRouteImport } from './routes/app.settings.autopilot'
import { Route as AppSettingsBillingRouteImport } from './routes/app.settings.billing'
import { Route as AppSettingsPrivacyRouteImport } from './routes/app.settings.privacy'
import { Route as AppSettingsProductsRouteImport } from './routes/app.settings.products'
import { Route as AppSettingsProfileRouteImport } from './routes/app.settings.profile'
import { Route as AppSettingsSecurityRouteImport } from './routes/app.settings.security'
import { Route as AppSettingsTrackingRouteImport } from './routes/app.settings.tracking'
import { Route as AppCampaignsCampaignIdIndexRouteImport } from './routes/app.campaigns.$campaignId.index'
import { Route as AppCampaignsCampaignIdActivityRouteImport } from './routes/app.campaigns.$campaignId.activity'
import { Route as AppCampaignsCampaignIdCreativesRouteImport } from './routes/app.campaigns.$campaignId.creatives'
import { Route as AppCampaignsCampaignIdForecastRouteImport } from './routes/app.campaigns.$campaignId.forecast'
import { Route as AppCampaignsCampaignIdIntelRouteImport } from './routes/app.campaigns.$campaignId.intel'
import { Route as AppCampaignsCampaignIdPolicyRouteImport } from './routes/app.campaigns.$campaignId.policy'
import { Route as AppCampaignsCampaignIdStoryRouteImport } from './routes/app.campaigns.$campaignId.story'
import { Route as AppCampaignsCampaignIdVideoRouteImport } from './routes/app.campaigns.$campaignId.video'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const DeletionStatusRoute = DeletionStatusRouteImport.update({
  id: '/deletion-status',
  path: '/deletion-status',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SubprocessorsRoute = SubprocessorsRouteImport.update({
  id: '/subprocessors',
  path: '/subprocessors',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdAccountsRoute = AppAdAccountsRouteImport.update({
  id: '/ad-accounts',
  path: '/ad-accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAudiencesRoute = AppAudiencesRouteImport.update({
  id: '/audiences',
  path: '/audiences',
  getParentRoute: () => AppRoute,
} as any)
const AppInsightsRoute = AppInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsRoute = AppOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsIdRoute = InvitationsIdRouteImport.update({
  id: '/invitations/$id',
  path: '/invitations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAiUsageRoute = AppAdminAiUsageRouteImport.update({
  id: '/ai-usage',
  path: '/ai-usage',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminCostRoute = AppAdminCostRouteImport.update({
  id: '/cost',
  path: '/cost',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLaunchFailuresRoute = AppAdminLaunchFailuresRouteImport.update({
  id: '/launch-failures',
  path: '/launch-failures',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLearningRoute = AppAdminLearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminModelsRoute = AppAdminModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminQueuesRoute = AppAdminQueuesRouteImport.update({
  id: '/queues',
  path: '/queues',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWatchdogRoute = AppAdminWatchdogRouteImport.update({
  id: '/watchdog',
  path: '/watchdog',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppCampaignsIndexRoute = AppCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsCampaignIdRoute = AppCampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => AppRoute,
} as any)
const AppCampaignsNewRoute = AppCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsAutopilotRoute = AppSettingsAutopilotRouteImport.update({
  id: '/autopilot',
  path: '/autopilot',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProductsRoute = AppSettingsProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTrackingRoute = AppSettingsTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppCampaignsCampaignIdIndexRoute =
  AppCampaignsCampaignIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdActivityRoute =
  AppCampaignsCampaignIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdCreativesRoute =
  AppCampaignsCampaignIdCreativesRouteImport.update({
    id: '/creatives',
    path: '/creatives',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdForecastRoute =
  AppCampaignsCampaignIdForecastRouteImport.update({
    id: '/forecast',
    path: '/forecast',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdIntelRoute =
  AppCampaignsCampaignIdIntelRouteImport.update({
    id: '/intel',
    path: '/intel',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdPolicyRoute =
  AppCampaignsCampaignIdPolicyRouteImport.update({
    id: '/policy',
    path: '/policy',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdStoryRoute =
  AppCampaignsCampaignIdStoryRouteImport.update({
    id: '/story',
    path: '/story',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)
const AppCampaignsCampaignIdVideoRoute =
  AppCampaignsCampaignIdVideoRouteImport.update({
    id: '/video',
    path: '/video',
    getParentRoute: () => AppCampaignsCampaignIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/deletion-status': typeof DeletionStatusRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/status': typeof StatusRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/ad-accounts': typeof AppAdAccountsRoute
  '/app/admin': typeof AppAdminRouteWithChildren
  '/app/audiences': typeof AppAudiencesRoute
  '/app/insights': typeof AppInsightsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/organizations': typeof AppOrganizationsRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/cost': typeof AppAdminCostRoute
  '/app/admin/launch-failures': typeof AppAdminLaunchFailuresRoute
  '/app/admin/learning': typeof AppAdminLearningRoute
  '/app/admin/models': typeof AppAdminModelsRoute
  '/app/admin/queues': typeof AppAdminQueuesRoute
  '/app/admin/watchdog': typeof AppAdminWatchdogRoute
  '/app/campaigns/$campaignId': typeof AppCampaignsCampaignIdRouteWithChildren
  '/app/campaigns/new': typeof AppCampaignsNewRoute
  '/app/settings/autopilot': typeof AppSettingsAutopilotRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/app/settings/products': typeof AppSettingsProductsRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/settings/tracking': typeof AppSettingsTrackingRoute
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/campaigns/': typeof AppCampaignsIndexRoute
  '/app/campaigns/$campaignId/activity': typeof AppCampaignsCampaignIdActivityRoute
  '/app/campaigns/$campaignId/creatives': typeof AppCampaignsCampaignIdCreativesRoute
  '/app/campaigns/$campaignId/forecast': typeof AppCampaignsCampaignIdForecastRoute
  '/app/campaigns/$campaignId/intel': typeof AppCampaignsCampaignIdIntelRoute
  '/app/campaigns/$campaignId/policy': typeof AppCampaignsCampaignIdPolicyRoute
  '/app/campaigns/$campaignId/story': typeof AppCampaignsCampaignIdStoryRoute
  '/app/campaigns/$campaignId/video': typeof AppCampaignsCampaignIdVideoRoute
  '/app/campaigns/$campaignId/': typeof AppCampaignsCampaignIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/deletion-status': typeof DeletionStatusRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/status': typeof StatusRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/ad-accounts': typeof AppAdAccountsRoute
  '/app/audiences': typeof AppAudiencesRoute
  '/app/insights': typeof AppInsightsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/organizations': typeof AppOrganizationsRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/app': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/cost': typeof AppAdminCostRoute
  '/app/admin/launch-failures': typeof AppAdminLaunchFailuresRoute
  '/app/admin/learning': typeof AppAdminLearningRoute
  '/app/admin/models': typeof AppAdminModelsRoute
  '/app/admin/queues': typeof AppAdminQueuesRoute
  '/app/admin/watchdog': typeof AppAdminWatchdogRoute
  '/app/campaigns/new': typeof AppCampaignsNewRoute
  '/app/settings/autopilot': typeof AppSettingsAutopilotRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/app/settings/products': typeof AppSettingsProductsRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/settings/tracking': typeof AppSettingsTrackingRoute
  '/app/admin': typeof AppAdminIndexRoute
  '/app/campaigns': typeof AppCampaignsIndexRoute
  '/app/campaigns/$campaignId/activity': typeof AppCampaignsCampaignIdActivityRoute
  '/app/campaigns/$campaignId/creatives': typeof AppCampaignsCampaignIdCreativesRoute
  '/app/campaigns/$campaignId/forecast': typeof AppCampaignsCampaignIdForecastRoute
  '/app/campaigns/$campaignId/intel': typeof AppCampaignsCampaignIdIntelRoute
  '/app/campaigns/$campaignId/policy': typeof AppCampaignsCampaignIdPolicyRoute
  '/app/campaigns/$campaignId/story': typeof AppCampaignsCampaignIdStoryRoute
  '/app/campaigns/$campaignId/video': typeof AppCampaignsCampaignIdVideoRoute
  '/app/campaigns/$campaignId': typeof AppCampaignsCampaignIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/deletion-status': typeof DeletionStatusRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/status': typeof StatusRoute
  '/subprocessors': typeof SubprocessorsRoute
  '/terms': typeof TermsRoute
  '/two-factor': typeof TwoFactorRoute
  '/verify-email': typeof VerifyEmailRoute
  '/app/ad-accounts': typeof AppAdAccountsRoute
  '/app/admin': typeof AppAdminRouteWithChildren
  '/app/audiences': typeof AppAudiencesRoute
  '/app/insights': typeof AppInsightsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/organizations': typeof AppOrganizationsRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/auth/error': typeof AuthErrorRoute
  '/invitations/$id': typeof InvitationsIdRoute
  '/app/': typeof AppIndexRoute
  '/app/admin/ai-usage': typeof AppAdminAiUsageRoute
  '/app/admin/cost': typeof AppAdminCostRoute
  '/app/admin/launch-failures': typeof AppAdminLaunchFailuresRoute
  '/app/admin/learning': typeof AppAdminLearningRoute
  '/app/admin/models': typeof AppAdminModelsRoute
  '/app/admin/queues': typeof AppAdminQueuesRoute
  '/app/admin/watchdog': typeof AppAdminWatchdogRoute
  '/app/campaigns/$campaignId': typeof AppCampaignsCampaignIdRouteWithChildren
  '/app/campaigns/new': typeof AppCampaignsNewRoute
  '/app/settings/autopilot': typeof AppSettingsAutopilotRoute
  '/app/settings/billing': typeof AppSettingsBillingRoute
  '/app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/app/settings/products': typeof AppSettingsProductsRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/settings/tracking': typeof AppSettingsTrackingRoute
  '/app/admin/': typeof AppAdminIndexRoute
  '/app/campaigns/': typeof AppCampaignsIndexRoute
  '/app/campaigns/$campaignId/activity': typeof AppCampaignsCampaignIdActivityRoute
  '/app/campaigns/$campaignId/creatives': typeof AppCampaignsCampaignIdCreativesRoute
  '/app/campaigns/$campaignId/forecast': typeof AppCampaignsCampaignIdForecastRoute
  '/app/campaigns/$campaignId/intel': typeof AppCampaignsCampaignIdIntelRoute
  '/app/campaigns/$campaignId/policy': typeof AppCampaignsCampaignIdPolicyRoute
  '/app/campaigns/$campaignId/story': typeof AppCampaignsCampaignIdStoryRoute
  '/app/campaigns/$campaignId/video': typeof AppCampaignsCampaignIdVideoRoute
  '/app/campaigns/$campaignId/': typeof AppCampaignsCampaignIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/deletion-status'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/status'
    | '/subprocessors'
    | '/terms'
    | '/two-factor'
    | '/verify-email'
    | '/app/ad-accounts'
    | '/app/admin'
    | '/app/audiences'
    | '/app/insights'
    | '/app/onboarding'
    | '/app/organizations'
    | '/app/settings'
    | '/auth/error'
    | '/invitations/$id'
    | '/app/'
    | '/app/admin/ai-usage'
    | '/app/admin/cost'
    | '/app/admin/launch-failures'
    | '/app/admin/learning'
    | '/app/admin/models'
    | '/app/admin/queues'
    | '/app/admin/watchdog'
    | '/app/campaigns/$campaignId'
    | '/app/campaigns/new'
    | '/app/settings/autopilot'
    | '/app/settings/billing'
    | '/app/settings/privacy'
    | '/app/settings/products'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/settings/tracking'
    | '/app/admin/'
    | '/app/campaigns/'
    | '/app/campaigns/$campaignId/activity'
    | '/app/campaigns/$campaignId/creatives'
    | '/app/campaigns/$campaignId/forecast'
    | '/app/campaigns/$campaignId/intel'
    | '/app/campaigns/$campaignId/policy'
    | '/app/campaigns/$campaignId/story'
    | '/app/campaigns/$campaignId/video'
    | '/app/campaigns/$campaignId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deletion-status'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/status'
    | '/subprocessors'
    | '/terms'
    | '/two-factor'
    | '/verify-email'
    | '/app/ad-accounts'
    | '/app/audiences'
    | '/app/insights'
    | '/app/onboarding'
    | '/app/organizations'
    | '/app/settings'
    | '/auth/error'
    | '/invitations/$id'
    | '/app'
    | '/app/admin/ai-usage'
    | '/app/admin/cost'
    | '/app/admin/launch-failures'
    | '/app/admin/learning'
    | '/app/admin/models'
    | '/app/admin/queues'
    | '/app/admin/watchdog'
    | '/app/campaigns/new'
    | '/app/settings/autopilot'
    | '/app/settings/billing'
    | '/app/settings/privacy'
    | '/app/settings/products'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/settings/tracking'
    | '/app/admin'
    | '/app/campaigns'
    | '/app/campaigns/$campaignId/activity'
    | '/app/campaigns/$campaignId/creatives'
    | '/app/campaigns/$campaignId/forecast'
    | '/app/campaigns/$campaignId/intel'
    | '/app/campaigns/$campaignId/policy'
    | '/app/campaigns/$campaignId/story'
    | '/app/campaigns/$campaignId/video'
    | '/app/campaigns/$campaignId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/deletion-status'
    | '/forgot-password'
    | '/login'
    | '/pricing'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/status'
    | '/subprocessors'
    | '/terms'
    | '/two-factor'
    | '/verify-email'
    | '/app/ad-accounts'
    | '/app/admin'
    | '/app/audiences'
    | '/app/insights'
    | '/app/onboarding'
    | '/app/organizations'
    | '/app/settings'
    | '/auth/error'
    | '/invitations/$id'
    | '/app/'
    | '/app/admin/ai-usage'
    | '/app/admin/cost'
    | '/app/admin/launch-failures'
    | '/app/admin/learning'
    | '/app/admin/models'
    | '/app/admin/queues'
    | '/app/admin/watchdog'
    | '/app/campaigns/$campaignId'
    | '/app/campaigns/new'
    | '/app/settings/autopilot'
    | '/app/settings/billing'
    | '/app/settings/privacy'
    | '/app/settings/products'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/settings/tracking'
    | '/app/admin/'
    | '/app/campaigns/'
    | '/app/campaigns/$campaignId/activity'
    | '/app/campaigns/$campaignId/creatives'
    | '/app/campaigns/$campaignId/forecast'
    | '/app/campaigns/$campaignId/intel'
    | '/app/campaigns/$campaignId/policy'
    | '/app/campaigns/$campaignId/story'
    | '/app/campaigns/$campaignId/video'
    | '/app/campaigns/$campaignId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DeletionStatusRoute: typeof DeletionStatusRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  StatusRoute: typeof StatusRoute
  SubprocessorsRoute: typeof SubprocessorsRoute
  TermsRoute: typeof TermsRoute
  TwoFactorRoute: typeof TwoFactorRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AuthErrorRoute: typeof AuthErrorRoute
  InvitationsIdRoute: typeof InvitationsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deletion-status': {
      id: '/deletion-status'
      path: '/deletion-status'
      fullPath: '/deletion-status'
      preLoaderRoute: typeof DeletionStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subprocessors': {
      id: '/subprocessors'
      path: '/subprocessors'
      fullPath: '/subprocessors'
      preLoaderRoute: typeof SubprocessorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/ad-accounts': {
      id: '/app/ad-accounts'
      path: '/ad-accounts'
      fullPath: '/app/ad-accounts'
      preLoaderRoute: typeof AppAdAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/audiences': {
      id: '/app/audiences'
      path: '/audiences'
      fullPath: '/app/audiences'
      preLoaderRoute: typeof AppAudiencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/insights': {
      id: '/app/insights'
      path: '/insights'
      fullPath: '/app/insights'
      preLoaderRoute: typeof AppInsightsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/organizations': {
      id: '/app/organizations'
      path: '/organizations'
      fullPath: '/app/organizations'
      preLoaderRoute: typeof AppOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/error': {
      id: '/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$id': {
      id: '/invitations/$id'
      path: '/invitations/$id'
      fullPath: '/invitations/$id'
      preLoaderRoute: typeof InvitationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/admin/': {
      id: '/app/admin/'
      path: '/'
      fullPath: '/app/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/ai-usage': {
      id: '/app/admin/ai-usage'
      path: '/ai-usage'
      fullPath: '/app/admin/ai-usage'
      preLoaderRoute: typeof AppAdminAiUsageRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/cost': {
      id: '/app/admin/cost'
      path: '/cost'
      fullPath: '/app/admin/cost'
      preLoaderRoute: typeof AppAdminCostRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/launch-failures': {
      id: '/app/admin/launch-failures'
      path: '/launch-failures'
      fullPath: '/app/admin/launch-failures'
      preLoaderRoute: typeof AppAdminLaunchFailuresRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/learning': {
      id: '/app/admin/learning'
      path: '/learning'
      fullPath: '/app/admin/learning'
      preLoaderRoute: typeof AppAdminLearningRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/models': {
      id: '/app/admin/models'
      path: '/models'
      fullPath: '/app/admin/models'
      preLoaderRoute: typeof AppAdminModelsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/queues': {
      id: '/app/admin/queues'
      path: '/queues'
      fullPath: '/app/admin/queues'
      preLoaderRoute: typeof AppAdminQueuesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/admin/watchdog': {
      id: '/app/admin/watchdog'
      path: '/watchdog'
      fullPath: '/app/admin/watchdog'
      preLoaderRoute: typeof AppAdminWatchdogRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/app/campaigns/': {
      id: '/app/campaigns/'
      path: '/campaigns'
      fullPath: '/app/campaigns/'
      preLoaderRoute: typeof AppCampaignsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/campaigns/$campaignId': {
      id: '/app/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/app/campaigns/$campaignId'
      preLoaderRoute: typeof AppCampaignsCampaignIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/campaigns/new': {
      id: '/app/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/app/campaigns/new'
      preLoaderRoute: typeof AppCampaignsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/autopilot': {
      id: '/app/settings/autopilot'
      path: '/autopilot'
      fullPath: '/app/settings/autopilot'
      preLoaderRoute: typeof AppSettingsAutopilotRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/billing': {
      id: '/app/settings/billing'
      path: '/billing'
      fullPath: '/app/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/privacy': {
      id: '/app/settings/privacy'
      path: '/privacy'
      fullPath: '/app/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/products': {
      id: '/app/settings/products'
      path: '/products'
      fullPath: '/app/settings/products'
      preLoaderRoute: typeof AppSettingsProductsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/profile': {
      id: '/app/settings/profile'
      path: '/profile'
      fullPath: '/app/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/security': {
      id: '/app/settings/security'
      path: '/security'
      fullPath: '/app/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/tracking': {
      id: '/app/settings/tracking'
      path: '/tracking'
      fullPath: '/app/settings/tracking'
      preLoaderRoute: typeof AppSettingsTrackingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/campaigns/$campaignId/': {
      id: '/app/campaigns/$campaignId/'
      path: '/'
      fullPath: '/app/campaigns/$campaignId/'
      preLoaderRoute: typeof AppCampaignsCampaignIdIndexRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/activity': {
      id: '/app/campaigns/$campaignId/activity'
      path: '/activity'
      fullPath: '/app/campaigns/$campaignId/activity'
      preLoaderRoute: typeof AppCampaignsCampaignIdActivityRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/creatives': {
      id: '/app/campaigns/$campaignId/creatives'
      path: '/creatives'
      fullPath: '/app/campaigns/$campaignId/creatives'
      preLoaderRoute: typeof AppCampaignsCampaignIdCreativesRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/forecast': {
      id: '/app/campaigns/$campaignId/forecast'
      path: '/forecast'
      fullPath: '/app/campaigns/$campaignId/forecast'
      preLoaderRoute: typeof AppCampaignsCampaignIdForecastRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/intel': {
      id: '/app/campaigns/$campaignId/intel'
      path: '/intel'
      fullPath: '/app/campaigns/$campaignId/intel'
      preLoaderRoute: typeof AppCampaignsCampaignIdIntelRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/policy': {
      id: '/app/campaigns/$campaignId/policy'
      path: '/policy'
      fullPath: '/app/campaigns/$campaignId/policy'
      preLoaderRoute: typeof AppCampaignsCampaignIdPolicyRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/story': {
      id: '/app/campaigns/$campaignId/story'
      path: '/story'
      fullPath: '/app/campaigns/$campaignId/story'
      preLoaderRoute: typeof AppCampaignsCampaignIdStoryRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
    '/app/campaigns/$campaignId/video': {
      id: '/app/campaigns/$campaignId/video'
      path: '/video'
      fullPath: '/app/campaigns/$campaignId/video'
      preLoaderRoute: typeof AppCampaignsCampaignIdVideoRouteImport
      parentRoute: typeof AppCampaignsCampaignIdRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAiUsageRoute: typeof AppAdminAiUsageRoute
  AppAdminCostRoute: typeof AppAdminCostRoute
  AppAdminLaunchFailuresRoute: typeof AppAdminLaunchFailuresRoute
  AppAdminLearningRoute: typeof AppAdminLearningRoute
  AppAdminModelsRoute: typeof AppAdminModelsRoute
  AppAdminQueuesRoute: typeof AppAdminQueuesRoute
  AppAdminWatchdogRoute: typeof AppAdminWatchdogRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAiUsageRoute: AppAdminAiUsageRoute,
  AppAdminCostRoute: AppAdminCostRoute,
  AppAdminLaunchFailuresRoute: AppAdminLaunchFailuresRoute,
  AppAdminLearningRoute: AppAdminLearningRoute,
  AppAdminModelsRoute: AppAdminModelsRoute,
  AppAdminQueuesRoute: AppAdminQueuesRoute,
  AppAdminWatchdogRoute: AppAdminWatchdogRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAutopilotRoute: typeof AppSettingsAutopilotRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsProductsRoute: typeof AppSettingsProductsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTrackingRoute: typeof AppSettingsTrackingRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAutopilotRoute: AppSettingsAutopilotRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsProductsRoute: AppSettingsProductsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTrackingRoute: AppSettingsTrackingRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppCampaignsCampaignIdRouteChildren {
  AppCampaignsCampaignIdActivityRoute: typeof AppCampaignsCampaignIdActivityRoute
  AppCampaignsCampaignIdCreativesRoute: typeof AppCampaignsCampaignIdCreativesRoute
  AppCampaignsCampaignIdForecastRoute: typeof AppCampaignsCampaignIdForecastRoute
  AppCampaignsCampaignIdIntelRoute: typeof AppCampaignsCampaignIdIntelRoute
  AppCampaignsCampaignIdPolicyRoute: typeof AppCampaignsCampaignIdPolicyRoute
  AppCampaignsCampaignIdStoryRoute: typeof AppCampaignsCampaignIdStoryRoute
  AppCampaignsCampaignIdVideoRoute: typeof AppCampaignsCampaignIdVideoRoute
  AppCampaignsCampaignIdIndexRoute: typeof AppCampaignsCampaignIdIndexRoute
}

const AppCampaignsCampaignIdRouteChildren: AppCampaignsCampaignIdRouteChildren =
  {
    AppCampaignsCampaignIdActivityRoute: AppCampaignsCampaignIdActivityRoute,
    AppCampaignsCampaignIdCreativesRoute: AppCampaignsCampaignIdCreativesRoute,
    AppCampaignsCampaignIdForecastRoute: AppCampaignsCampaignIdForecastRoute,
    AppCampaignsCampaignIdIntelRoute: AppCampaignsCampaignIdIntelRoute,
    AppCampaignsCampaignIdPolicyRoute: AppCampaignsCampaignIdPolicyRoute,
    AppCampaignsCampaignIdStoryRoute: AppCampaignsCampaignIdStoryRoute,
    AppCampaignsCampaignIdVideoRoute: AppCampaignsCampaignIdVideoRoute,
    AppCampaignsCampaignIdIndexRoute: AppCampaignsCampaignIdIndexRoute,
  }

const AppCampaignsCampaignIdRouteWithChildren =
  AppCampaignsCampaignIdRoute._addFileChildren(
    AppCampaignsCampaignIdRouteChildren,
  )

interface AppRouteChildren {
  AppAdAccountsRoute: typeof AppAdAccountsRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAudiencesRoute: typeof AppAudiencesRoute
  AppInsightsRoute: typeof AppInsightsRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppOrganizationsRoute: typeof AppOrganizationsRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCampaignsCampaignIdRoute: typeof AppCampaignsCampaignIdRouteWithChildren
  AppCampaignsNewRoute: typeof AppCampaignsNewRoute
  AppCampaignsIndexRoute: typeof AppCampaignsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdAccountsRoute: AppAdAccountsRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAudiencesRoute: AppAudiencesRoute,
  AppInsightsRoute: AppInsightsRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppOrganizationsRoute: AppOrganizationsRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCampaignsCampaignIdRoute: AppCampaignsCampaignIdRouteWithChildren,
  AppCampaignsNewRoute: AppCampaignsNewRoute,
  AppCampaignsIndexRoute: AppCampaignsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DeletionStatusRoute: DeletionStatusRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  StatusRoute: StatusRoute,
  SubprocessorsRoute: SubprocessorsRoute,
  TermsRoute: TermsRoute,
  TwoFactorRoute: TwoFactorRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AuthErrorRoute: AuthErrorRoute,
  InvitationsIdRoute: InvitationsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
